import type { SecondFactor, StaffMe } from '@central/api';

/**
 * Where a staff sign-in stands after its first step: a second factor to
 * verify, a first one to enroll, then recovery codes to save.
 */
export type FactorStep =
  { kind: 'verify'; methods: SecondFactor[] } | { kind: 'enroll' } | { kind: 'codes'; me: StaffMe };

/** The second factor a login or setup answer leads to. */
export function nextStep(methods: SecondFactor[] | undefined): FactorStep {
  return methods?.length ? { kind: 'verify', methods } : { kind: 'enroll' };
}
